import React from 'react';
import styled from "@emotion/styled";
import { Icon } from "@iconify/react";
import { FormControl, MenuItem } from "@mui/material";
import Modal from "@mui/material/Modal";
import Select from "@mui/material/Select";
import { useMemo, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import { formatAmount } from "../../lib/utils";
import { useEmployee } from "../../services";

function EmployeeDetails({ employeeData }) {
  const {
    name,
    email,
    contact,
    age,
    gender,
    current_salary,
    employment_period,
    resume_url,
    status,
    salary,
    payslips,
    aadhar,
    pan,
    designation,
    department,
  } = employeeData;
  const { requestPasswordReset } = useEmployee();
  const [showNewPasswordModal, setShowNewPasswordModal] = useState(false);
  const [newPasswordData, setNewPasswordData] = useState({});
  const [params] = useSearchParams();

  const handleStatusChange = (event) => {
    console.log(event.target.value);
  };
  // to do: handle month and year change

  const handleResetPassword = async () => {
    const id = params.get("id");
    if (!id) {
      toast.error("An error occurred during password reset. Please try again.");
      window.location.reload();
      return;
    }
    const { data, error } = await requestPasswordReset(id);
    if (error) toast.error(error);
    else {
      setNewPasswordData(data);
      setShowNewPasswordModal(true);
    }
  };

  const renderRow = (label, value) => (
    <div className="row align_start small">
      <span className="label gray">{label}</span>
      <span className="value">{value}</span>
    </div>
  );

  const monthlySalary = useMemo(() => (current_salary ? current_salary / 12 : 0), [current_salary]);
  const professionalFees = 200;
  const tdsValue = useMemo(
    () => (monthlySalary ? (monthlySalary * 0.1).toFixed(2).replace(".00", "") : 0),
    [monthlySalary]
  );
  const inHandSalary = useMemo(
    () => (monthlySalary ? Number(monthlySalary) - Number(tdsValue) - Number(professionalFees || 0) : 0),
    [monthlySalary, tdsValue]
  );
  const hourlySalary = useMemo(() => (inHandSalary ? inHandSalary / (5 * 8.5) : 0), [inHandSalary]);

  return (
    <>
      <section className="column">
        <div className="row">
          <span>{name} details</span>
          <div className="row end">
            <button className="btn ghost_btn no_underline">
              Edit
              <Icon icon="carbon:edit" />
            </button>
            <button className="btn cta_outline_btn" onClick={handleResetPassword}>
              Reset Password
            </button>
          </div>
        </div>
        <div className="grid-2-cols-with-divider small">
          <div className="column">
            {renderRow("Employee Name", name)}
            <div className="row">
              {renderRow("Age", age)}
              {renderRow("Gender", gender)}
            </div>
            {renderRow("Contact Number", contact)}
            {renderRow("Email ID", email)}
            {renderRow("Designation", designation)}
            {renderRow("Department", department)}
          </div>
          <div className="column">
            {renderRow("Aadhar Number", aadhar)}
            {renderRow("PAN Number", pan)}
            {renderRow("Employment Period", employment_period)}
            <div className="row">
              <span className="gray">Current Salary</span>
              <div className="row end">
                <button className="btn ghost_btn">view details</button>
                <span>{formatAmount(current_salary)} LPA</span>
              </div>
            </div>
            <div className="row small">
              <span className="gray">Resume</span>
              <Link to={resume_url} target="_blank" className="ghost_btn">
                view
              </Link>
            </div>
            <div className="row">
              <span className="gray">Employment Status</span>
              <FormControl size="small">
                <Select
                  value={status}
                  onChange={handleStatusChange}
                  sx={{
                    fontSize: "0.875rem",
                    borderRadius: "0.375rem",
                    "& .MuiInputBase-input": {
                      py: 1,
                      px: 2.5,
                      borderColor: "red",
                      "&:focus": { outline: "none", borderColor: "transparent" },
                    },
                    "&.Mui-focused fieldset": { borderColor: "" },
                  }}
                  renderValue={(selected) => (selected ? selected : "Select status")}
                  displayEmpty
                >
                  <MenuItem value="active">Active</MenuItem>
                  <MenuItem value="terminated">Terminated</MenuItem>
                  <MenuItem value="resigned">Resigned</MenuItem>
                </Select>
              </FormControl>
            </div>
          </div>
        </div>
      </section>
      <section className="column">
        <section className="row">
          <span>Payslip</span>
          <div className="row end">
            <FormControl size="small">
              <Select
                sx={{
                  fontSize: "0.875rem",
                }}
                renderValue={(selected) => (selected ? String(selected) : "Select month") as React.ReactNode}
                displayEmpty
              >
                <MenuItem value="january">January</MenuItem>
                <MenuItem value="february">February</MenuItem>
                <MenuItem value="march">March</MenuItem>
              </Select>
            </FormControl>
            <FormControl size="small">
              <Select
                sx={{
                  fontSize: "0.875rem",
                  "& .MuiInputBase-input": {
                    py: 1,
                    px: 2.5,
                    borderColor: "red",
                    "&:focus": { outline: "none", borderColor: "transparent" },
                  },
                  "&.Mui-focused fieldset": { borderColor: "" },
                }}
                renderValue={(selected) => (selected ? String(selected) : "Select year") as React.ReactNode}
                displayEmpty
              >
                <MenuItem value="2023">2023</MenuItem>
                <MenuItem value="2022">2022</MenuItem>
                <MenuItem value="2021">2021</MenuItem>
              </Select>
            </FormControl>
          </div>
        </section>
        <div className="column shrink small">
          {payslips.map((payslip) => (
            <div className="row">
              <span>
                {payslip.month} {payslip.year}
              </span>
              <div className="row end">
                <Link to={payslip.url} target="_blank" className="ghost_btn">
                  view
                </Link>
                <button className="btn cta_outline_btn">Download</button>
              </div>
            </div>
          ))}
        </div>
      </section>
      {/* <section className="column">
        <section className="row">
          <span>Current Salary details</span>
          <button className="btn ghost_btn no_underline">
            Edit
            <Icon icon="carbon:edit" />
          </button>
        </section>
        <section className={`${styles.salary_details} small`}>
          <div className={styles.table}>
            <div className={styles.table_header}>
              <div className={styles.table_row}>
                <div className={styles.table_cell}>Deductions</div>
                <div className={styles.table_cell}>Amount</div>
                <div className={styles.table_cell}>YTD</div>
              </div>
            </div>
            <div className={styles.table_body}>
              {salary.deductions.map((deduction) => (
                <div className={styles.table_row}>
                  <div className={styles.table_cell}>{deduction.title}</div>
                  <div className={styles.table_cell}>{formatAmount(deduction.amount)}</div>
                  <div className={styles.table_cell}>{formatAmount(deduction.ytd)}</div>
                </div>
              ))}
            </div>
            <div className={styles.table_footer}>
              <div className={styles.table_row}>
                <div className={styles.table_cell}>Gross Earnings</div>
                <div className={styles.table_cell}>{formatAmount(salary.gross_earnings)}</div>
                <div></div>
              </div>
            </div>
          </div>
          <div className={styles.table}>
            <div className={styles.table_header}>
              <div className={styles.table_row}>
                <div className={styles.table_cell}>Earnings</div>
                <div className={styles.table_cell}>Amount</div>
                <div className={styles.table_cell}>YTD</div>
              </div>
            </div>
            <div className={styles.table_body}>
              {salary.earnings.map((earning) => (
                <div className={styles.table_row}>
                  <div className={styles.table_cell}>{earning.title}</div>
                  <div className={styles.table_cell}>{formatAmount(earning.amount)}</div>
                  <div className={styles.table_cell}>{formatAmount(earning.ytd)}</div>
                </div>
              ))}
            </div>
            <div className={styles.table_footer}>
              <div className={styles.table_row}>
                <div className={styles.table_cell}>Total Deductions</div>
                <div className={styles.table_cell}>{formatAmount(salary.total_deductions)}</div>
                <div></div>
              </div>
            </div>
          </div>
        </section>
      </section> */}
      <div className="row align_start">
        <span>Salary Structure</span>
        <table className="salary_table small">
          <tbody>
            <tr>
              <td>Salary per annum</td>
              <td>{formatAmount(current_salary)}</td>
            </tr>
            <tr>
              <td>Salary per month</td>
              <td>{formatAmount(monthlySalary)}</td>
            </tr>
            <tr>
              <td>Professional Fees</td>
              <td>- {formatAmount(professionalFees)}</td>
            </tr>
            <tr>
              <td>TDS (10%)</td>
              <td>- {formatAmount(tdsValue)}</td>
            </tr>
            <tr>
              <td>Salary in hand per month</td>
              <td>{formatAmount(inHandSalary)}</td>
            </tr>
            <tr>
              <td>Salary per hour</td>
              <td>{formatAmount(hourlySalary.toFixed(2).replace(".00", ""))}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <NewPasswordModal
        open={showNewPasswordModal}
        onClose={() => setShowNewPasswordModal(false)}
        data={newPasswordData}
      />
    </>
  );
}

export default EmployeeDetails;

const ModalWrapper = styled(Modal)({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
});

function NewPasswordModal({ open, onClose, data }) {
  const [copied, setCopied] = useState(false);
  const handleCopyToClipboard = () => {
    navigator.clipboard.writeText(data.new_password);
    setCopied(true);
    setTimeout(() => {
      setCopied(false);
    }, 10000);
  };

  return (
    <ModalWrapper
      open={open}
      onClose={onClose}
      aria-labelledby="new-password-modal"
      aria-describedby="new-password-modal"
    >
      <div className="modal_container fit column">
        <h3 className="text_center">Reset Password</h3>
        <div className="grid_3 spread-col">
          <span className="label gray">User ID</span>
          <span className="= self-start">{data.user_id}</span>
        </div>
        <div className="grid_3 spread-col">
          <span className="label gray">Password</span>
          <span className=" self-start">{data.new_password}</span>
          <button className="btn ghost_btn no_underline" onClick={handleCopyToClipboard} disabled={!data.new_password}>
            <Icon icon="tabler:copy" />
            {copied ? "Copied!" : "Copy"}
          </button>
        </div>
      </div>
    </ModalWrapper>
  );
}
